import EnterpriseDetails from "./EnterpriseDetails";

export default EnterpriseDetails;
